<template>
  <scout-form
    label="除外する会員を指定"
    has-child
  >
    <dummy-scout-form
      :is-modified="isModifiedThisJob"
      label="この自社求人でスカウトした時期を指定して除外"
      data-test="scout-this-job"
    >
      <term-select
        :selected-option.sync="scoutThisJobOption"
        :from.sync="scoutThisJobFrom"
        :to.sync="scoutThisJobTo"
        :without-today="true"
        notice="※現在の掲載期間中にスカウトした会員は、スカウト済み一覧から再送できるため、すでに除外されています。現在の掲載期間よりも前にスカウトしたことがある会員を除外したい場合に、こちらを指定してください。"
        date-label="スカウト送信日"
        data-test="scout-this-job-term"
      />
    </dummy-scout-form>
    <dummy-scout-form
      :is-modified="isModifiedOtherJob"
      label="その他の自社求人でスカウトした時期を指定して除外"
      data-test="scout-other-job"
    >
      <term-select
        :without-today="true"
        :selected-option.sync="scoutOtherJobOption"
        :from.sync="scoutOtherJobFrom"
        :to.sync="scoutOtherJobTo"
        date-label="スカウト送信日"
        data-test="scout-other-job-term"
      />
    </dummy-scout-form>
    <dummy-scout-form
      :is-modified="isModifiedLiked"
      label="いいねを送信した時期を指定して除外"
      data-test="liked"
    >
      <term-select
        :selected-option.sync="likedOption"
        :from.sync="likedFrom"
        :to.sync="likedTo"
        :without-today="true"
        date-label="いいね送信日"
        data-test="liked-term"
      />
    </dummy-scout-form>
    <dummy-scout-form
      :is-modified="hasCandidateOtherJob"
      data-test="candidate-other-job"
      label="送信候補"
    >
      <label class="boss-checkbox">
        <input
          v-model="hasCandidateOtherJob"
          class="boss-input-checkbox"
          type="checkbox"
          data-test="applies-other-company"
        >その他の自社求人で送信候補に入れている会員を除外
      </label>
      <div class="boss-annotation-text">
        ※この自社求人で送信候補に入れている会員はすでに除外されています。
      </div>
    </dummy-scout-form>
    <scout-form-other-excludes
      :applies-other-company="appliesOtherCompany"
      :applies-casual-interview-entry-other-company="appliesCasualInterviewEntryOtherCompany"
      @update:appliesOtherCompany="$emit('update:applies-other-company', $event)"
      @update:appliesCasualInterviewEntryOtherCompany="$emit('update:applies-casual-interview-entry-other-company', $event)"
    />
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import DummyScoutForm from '@/components/atoms/DummyScoutForm'
import TermSelect from '@/components/atoms/TermSelect'
import ScoutFormOtherExcludes from '@/components/atoms/ScoutFormOtherExcludes'

export default {
  components: {
    ScoutForm,
    DummyScoutForm,
    TermSelect,
    ScoutFormOtherExcludes
  },
  props: {
    appliesOtherCompany: {
      required: true,
      type: Boolean
    },
    appliesCasualInterviewEntryOtherCompany: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      scoutThisJobOption: {},
      scoutThisJobFrom: '',
      scoutThisJobTo: '',
      scoutOtherJobOption: {},
      scoutOtherJobFrom: '',
      scoutOtherJobTo: '',
      likedOption: {},
      likedFrom: '',
      likedTo: '',
      hasCandidateOtherJob: false
    }
  },
  computed: {
    isModifiedThisJob () {
      return !!this.scoutThisJobFrom && !!this.scoutThisJobTo
    },
    isModifiedOtherJob () {
      return !!this.scoutOtherJobFrom && !!this.scoutOtherJobTo
    },
    isModifiedLiked () {
      return !!this.likedFrom && !!this.likedTo
    }
  }
}
</script>
